"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BusinessCustomerAddress = _interopRequireDefault(require("../model/BusinessCustomerAddress"));
var _BusinessCustomerAddressQueryResult = _interopRequireDefault(require("../model/BusinessCustomerAddressQueryResult"));
var _CreateCustomerAddressCommand = _interopRequireDefault(require("../model/CreateCustomerAddressCommand"));
var _CustomerAddressQuery = _interopRequireDefault(require("../model/CustomerAddressQuery"));
var _UpdateCustomerAddressCommand = _interopRequireDefault(require("../model/UpdateCustomerAddressCommand"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* Addresses service.
* @module api/AddressesApi
* @version 1.1.3-alpha.1
*/
class AddressesApi {
  /**
  * Constructs a new AddressesApi. 
  * @alias module:api/AddressesApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Create a new customer address
   * Creates a new customer address and returns the created object
   * @param {Object} opts Optional parameters
   * @param {module:model/CreateCustomerAddressCommand} opts.CreateCustomerAddressCommand 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessCustomerAddress} and HTTP response
   */
  createWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['CreateCustomerAddressCommand'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = _BusinessCustomerAddress.default;
    return this.apiClient.callApi('/api/v1/Addresses', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Create a new customer address
   * Creates a new customer address and returns the created object
   * @param {Object} opts Optional parameters
   * @param {module:model/CreateCustomerAddressCommand} opts.CreateCustomerAddressCommand 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessCustomerAddress}
   */
  create(opts) {
    return this.createWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Get customer address
   * Returns the requested customer address
   * @param {Number} id Id of the customer address to get
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessCustomerAddress} and HTTP response
   */
  getWithHttpInfo(id) {
    let postBody = null;
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling get");
    }
    let pathParams = {
      'id': id
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _BusinessCustomerAddress.default;
    return this.apiClient.callApi('/api/v1/Addresses/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get customer address
   * Returns the requested customer address
   * @param {Number} id Id of the customer address to get
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessCustomerAddress}
   */
  get(id) {
    return this.getWithHttpInfo(id).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Get multiple customer addresses
   * Returns an array of requested customer addresses
   * @param {Object} opts Optional parameters
   * @param {Array.<Number>} opts.request_body Ids of the customer addresses to get. Not specifiying ids will return all customer addresses
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BusinessCustomerAddress>} and HTTP response
   */
  getManyWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['request_body'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = [_BusinessCustomerAddress.default];
    return this.apiClient.callApi('/api/v1/Addresses/getMany', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Get multiple customer addresses
   * Returns an array of requested customer addresses
   * @param {Object} opts Optional parameters
   * @param {Array.<Number>} opts.request_body Ids of the customer addresses to get. Not specifiying ids will return all customer addresses
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BusinessCustomerAddress>}
   */
  getMany(opts) {
    return this.getManyWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Query customer addresses
   * Queries customer addresses and returns a filtered, sorted and paged result
   * @param {Object} opts Optional parameters
   * @param {module:model/CustomerAddressQuery} opts.CustomerAddressQuery 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessCustomerAddressQueryResult} and HTTP response
   */
  queryWithHttpInfo(opts) {
    opts = opts || {};
    let postBody = opts['CustomerAddressQuery'];
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = _BusinessCustomerAddressQueryResult.default;
    return this.apiClient.callApi('/api/v1/Addresses/query', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Query customer addresses
   * Queries customer addresses and returns a filtered, sorted and paged result
   * @param {Object} opts Optional parameters
   * @param {module:model/CustomerAddressQuery} opts.CustomerAddressQuery 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessCustomerAddressQueryResult}
   */
  query(opts) {
    return this.queryWithHttpInfo(opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Delete customer address
   * Deletes a customer address and returns the deleted object
   * @param {Number} id Id of the customer address to delete
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessCustomerAddress} and HTTP response
   */
  removeWithHttpInfo(id) {
    let postBody = null;
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling remove");
    }
    let pathParams = {
      'id': id
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _BusinessCustomerAddress.default;
    return this.apiClient.callApi('/api/v1/Addresses/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Delete customer address
   * Deletes a customer address and returns the deleted object
   * @param {Number} id Id of the customer address to delete
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessCustomerAddress}
   */
  remove(id) {
    return this.removeWithHttpInfo(id).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Delete multiple customer addresses
   * Deletes multiple customer addresses and returns a list of the deleted records
   * @param {Array.<Number>} request_body Ids of the customer addresses to delete
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BusinessCustomerAddress>} and HTTP response
   */
  removeManyWithHttpInfo(request_body) {
    let postBody = request_body;
    // verify the required parameter 'request_body' is set
    if (request_body === undefined || request_body === null) {
      throw new Error("Missing the required parameter 'request_body' when calling removeMany");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = [_BusinessCustomerAddress.default];
    return this.apiClient.callApi('/api/v1/Addresses/removeMany', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Delete multiple customer addresses
   * Deletes multiple customer addresses and returns a list of the deleted records
   * @param {Array.<Number>} request_body Ids of the customer addresses to delete
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BusinessCustomerAddress>}
   */
  removeMany(request_body) {
    return this.removeManyWithHttpInfo(request_body).then(function (response_and_data) {
      return response_and_data.data;
    });
  }

  /**
   * Update customer address
   * Updates a customer address and returns the updated object
   * @param {Number} id Id of the customer address to update
   * @param {Object} opts Optional parameters
   * @param {module:model/UpdateCustomerAddressCommand} opts.UpdateCustomerAddressCommand 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessCustomerAddress} and HTTP response
   */
  updateWithHttpInfo(id, opts) {
    opts = opts || {};
    let postBody = opts['UpdateCustomerAddressCommand'];
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling update");
    }
    let pathParams = {
      'id': id
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['Bearer'];
    let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    let accepts = ['application/json'];
    let returnType = _BusinessCustomerAddress.default;
    return this.apiClient.callApi('/api/v1/Addresses/{id}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
  }

  /**
   * Update customer address
   * Updates a customer address and returns the updated object
   * @param {Number} id Id of the customer address to update
   * @param {Object} opts Optional parameters
   * @param {module:model/UpdateCustomerAddressCommand} opts.UpdateCustomerAddressCommand 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessCustomerAddress}
   */
  update(id, opts) {
    return this.updateWithHttpInfo(id, opts).then(function (response_and_data) {
      return response_and_data.data;
    });
  }
}
exports.default = AddressesApi;